var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvenience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.72937 15.9073C4.75772 15.9073 1.53074 12.6803 1.53074 8.70869C1.53074 4.73703 4.75772 1.51006 8.72937 1.51006C12.6803 1.51006 15.928 4.73703 15.928 8.70869C15.928 9.2672 15.8659 9.78434 15.7625 10.3015C15.8453 10.2808 15.928 10.2808 16.0107 10.2808C16.4658 10.2808 16.8795 10.3429 17.2933 10.467C17.4174 9.90846 17.4587 9.30857 17.4587 8.70869C17.4587 3.9096 13.5491 0 8.75006 0C3.9096 0.0206857 0 3.93029 0 8.72937C0 13.5285 3.9096 17.4381 8.72937 17.4381C9.90846 17.4381 11.0255 17.2105 12.0598 16.7761C11.8322 16.3417 11.6667 15.8453 11.6047 15.3074C10.7152 15.7005 9.74297 15.9073 8.72937 15.9073Z",
    fill: "#11BF0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9902 11.0666C13.963 11.0666 12.3081 12.7008 12.3081 14.728C12.3081 16.7552 13.9423 18.3894 15.9695 18.3894C17.9967 18.3894 19.6308 16.7552 19.6308 14.728C19.6515 12.7008 18.0174 11.0666 15.9902 11.0666ZM17.4175 15.6382C17.5623 15.783 17.5623 16.0105 17.4175 16.1553C17.3554 16.2174 17.252 16.2587 17.1692 16.2587C17.0865 16.2587 16.9831 16.2174 16.921 16.1553L16.0108 15.2451L15.1007 16.1553C15.0386 16.2174 14.9352 16.2587 14.8524 16.2587C14.7697 16.2587 14.6663 16.2174 14.6042 16.1553C14.4594 16.0105 14.4594 15.783 14.6042 15.6382L15.5144 14.728L14.6042 13.8178C14.4594 13.673 14.4594 13.4455 14.6042 13.3007C14.749 13.1559 14.9766 13.1559 15.1214 13.3007L16.0315 14.2108L16.9417 13.3007C17.0865 13.1559 17.314 13.1559 17.4588 13.3007C17.6036 13.4455 17.6036 13.673 17.4588 13.8178L16.5487 14.728L17.4175 15.6382Z",
    fill: "#11BF0E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.39695 8.18514H5.79199L9.95078 12.6181L10.5449 12.0012L7.75714 9.03061H8.44265C9.40237 9.00776 10.2021 8.27655 10.3849 7.31682H11.7103V6.47136H10.3849C10.3164 6.15145 10.2021 5.85439 10.0193 5.60304H11.7103V4.75757H6.22615V5.60304H8.39695C8.92251 5.60304 9.35667 5.96864 9.51662 6.47136H6.22615V7.31682H9.53947C9.35667 7.81954 8.92251 8.18514 8.39695 8.18514Z",
    fill: "#11BF0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenience);
export default __webpack_public_path__ + "static/media/Convenience.05ded4d9183a07d1f892fb7978a19ba7.svg";
export { ForwardRef as ReactComponent };